import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {SELECTABLE_PACKAGES} from "../../../tenant/Config/ApiUrl";

const state = {
    selectable: []
}

const actions = {
    getSelectablePackages({commit, state}) {
        if (!Object.keys(state.selectable).length) {
            axiosGet(SELECTABLE_PACKAGES).then(({data}) => {
                data = data.map(subscriptionPackage => {
                    return {
                        id: subscriptionPackage.id,
                        value: subscriptionPackage.name + ` ( ${subscriptionPackage.billing_cycle} )`
                    }
                });
                commit('PACKAGE_LIST', data)
            });
        }
    }
}

const mutations = {
    PACKAGE_LIST(state, data) {
        state.selectable = data;
    }
}

export default {
    state,
    actions,
    mutations
}
